import { memo, useEffect } from 'react';
import { SignUp } from '@clerk/clerk-react';
import AuthShell from '../../auth/AuthShell';
import SignedInRedirect from './SignedInRedirect';
import {
  CLERK_SIGN_IN_URL,
  CLERK_SIGN_UP_URL,
  CLERK_AFTER_SIGN_UP_URL,
} from '../../auth/clerkConfig';
import { logAuthMount } from '../../auth/authLifecycleDebug';
import ClerkSignUpLifecycleProbe from './ClerkSignUpLifecycleProbe';

/**
 * Stable Clerk SignUp instance — appearance comes from ClerkProvider, not per-render props.
 * fallbackRedirectUrl (not forceRedirectUrl) avoids re-initialization during multi-step signup.
 */
const ClerkSignUp = memo(function ClerkSignUp() {
  useEffect(() => {
    const cleanup = logAuthMount('ClerkSignUp');
    return cleanup;
  }, []);

  return (
    <SignUp
      routing="path"
      path={CLERK_SIGN_UP_URL}
      signInUrl={CLERK_SIGN_IN_URL}
      fallbackRedirectUrl={CLERK_AFTER_SIGN_UP_URL}
    />
  );
});

function SignupPage() {
  useEffect(() => {
    const cleanup = logAuthMount('SignupPage');
    return cleanup;
  }, []);

  return (
    <SignedInRedirect>
      <ClerkSignUpLifecycleProbe />
      <AuthShell title="Signup">
        <ClerkSignUp />
      </AuthShell>
    </SignedInRedirect>
  );
}

export default memo(SignupPage);
